
let initialState = {
  'Anonymous': true,
  'Role': 'Neznámý uživatel',
  'Username': '',
  'DisplayName': '',
  'UserRoles': [],
  'Language': '',
  'LastSelectedProduct': null,
  'LastSelectedSampleCard': null,
  'LastSelectedColor': null,
  'ProductGroups': null,
  'RememberFieldsValues': false,
  'Email':'',
  'FullName':'',
  'Phone':''
};

export const userReducer = (state: any = initialState, action: any) => {

  switch (action.type) {

    case 'USER_SETTINGS':

      var newState = { ...state };
      var payload = JSON.parse(action.payload);
      newState.RememberFieldsValues = payload.rememberFieldsValues;

      return newState;

    case 'USER_LOGIN':

      var newState = { ...state };

      var payload = JSON.parse(action.payload);

      newState.Role = payload.role;
      newState.Anonymous = payload.anonymous;
      newState.Username = payload.username;
      newState.UserRoles = payload.userRoles;
      newState.SellerId = payload.sellerId;
      newState.SellerName = payload.sellerName;
      newState.Language = payload.language;
      newState.LastSelectedProduct = payload.lastSelectedProduct;
      newState.LastSelectedSampleCard = payload.lastSelectedSampleCard;
      newState.LastSelectedColor = payload.lastSelectedColor;
      newState.CountryCode = payload.countryCode;
      newState.IsSuperAdmin = payload.isSuperAdmin;
      newState.ProductGroups = payload.productGroups;
      newState.RememberFieldsValues = payload.rememberFieldsValues;

      newState.FullName = payload.fullName;
      newState.Email = payload.email;
      newState.Phone = payload.phone;

      return newState;


    case 'USER_LOGOUT':

      var newState = { ...state };

      var payload = JSON.parse(action.payload);

      newState.Role = payload.role;
      newState.Anonymous = payload.anonymous;
      newState.Username = payload.username;

      return newState;

  }

  return state;
}